import { render, staticRenderFns } from "./journey-step-contacts-widget.vue?vue&type=template&id=72a78f8a&"
import script from "./journey-step-contacts-widget.vue?vue&type=script&lang=js&"
export * from "./journey-step-contacts-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-step-contacts-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports